import React, { Fragment, useState } from "react";

import classnames from "classnames";
import { useForm } from "react-hook-form";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Label,
  Input,
  Form,
} from "reactstrap";

import "eva-icons/style/eva-icons.css";

const AddEventSidebar = (props) => {
  const {
    store,
    dispatch,
    open,
    handleAddItem,
    refetchItems,
    addItem,
    selectFacility,
    updateItem,
  } = props;

  const selectedItem = store.selectedGroup;
  const { register, errors, handleSubmit } = useForm();

  const [name, setName] = useState("");
  const [building_id, setBuildingID] = useState("");

  const isObjEmpty = (obj) => Object.keys(obj).length === 0;

  const handleAddEvent = () => {
    const obj = {
      name,
      building_id,
    };
    dispatch(addItem(obj));
    refetchItems();
    handleAddItem();
  };

  const handleSelectedEvent = () => {
    if (!isObjEmpty(selectedItem)) {
      setName(selectedItem.name || name);
      setBuildingID(selectedItem.building_id || building_id);
    }
  };

  const handleResetInputValues = () => {
    dispatch(selectFacility({}));

    setName("");
    setBuildingID("");
  };

  const handleUpdateEvent = () => {
    const itemToUpdate = {
      id: selectedItem.id,
      name,
      building_id,
    };

    dispatch(updateItem(itemToUpdate));
    handleAddItem();
  };

  const EventActions = () => {
    if (
      isObjEmpty(selectedItem) ||
      (!isObjEmpty(selectedItem) && !selectedItem.name.length)
    ) {
      return (
        <Fragment>
          <Button className="mr-3 btn-rounded" type="submit" color="primary">
            Add
          </Button>
          <Button
            className="btn-rounded"
            color="secondary"
            type="reset"
            onClick={handleAddItem}
            outline
          >
            Cancel
          </Button>
        </Fragment>
      );
    } else {
      return (
        <Fragment>
          <Button
            className="mr-3 btn-rounded"
            color="primary"
            onClick={handleUpdateEvent}
          >
            Update
          </Button>
          <Button
            className="btn-rounded"
            color="secondary"
            type="reset"
            onClick={handleAddItem}
            outline
          >
            Cancel
          </Button>
        </Fragment>
      );
    }
  };

  const CloseBtn = (
    <i className="eva eva-close cursor-pointer" onClick={handleAddItem} />
  );

  return (
    <Modal
      isOpen={open}
      toggle={handleAddItem}
      onOpened={handleSelectedEvent}
      onClosed={handleResetInputValues}
      className="sidebar-lg"
      contentClassName="p-0"
      modalClassName="modal-slide-in event-sidebar"
    >
      <ModalHeader
        className="mb-1"
        toggle={handleAddItem}
        close={CloseBtn}
        tag="div"
      >
        <h5 className="modal-title">
          {selectedItem && selectedItem.title && selectedItem.title.length
            ? "Update"
            : "Add"}{" "}
          Group
        </h5>
      </ModalHeader>
      <ModalBody className="flex-grow-1 pb-sm-0 pb-3">
        <Form
          onSubmit={handleSubmit((data) => {
            if (isObjEmpty(errors)) {
              if (
                isObjEmpty(selectedItem) ||
                (!isObjEmpty(selectedItem) && !selectedItem.title.length)
              ) {
                handleAddEvent();
              } else {
                handleUpdateEvent();
              }
              handleAddItem();
            }
          })}
        >
          <FormGroup>
            <Label for="name">
              Name <span className="text-danger">*</span>
            </Label>
            <Input
              id="name"
              name="name"
              placeholder="City Hall"
              value={name}
              onChange={(e) => setName(e.target.value)}
              innerRef={register({
                register: true,
                validate: (value) => value !== "",
              })}
              className={classnames({
                "is-invalid": errors.title,
                // add extended bootstrap class for show invalid field value
              })}
            />
          </FormGroup>
          <FormGroup>
            <Label for="building_id">
              Building ID <span className="text-danger">*</span>
            </Label>
            <Input
              id="building_id"
              name="building_id"
              placeholder="18"
              value={building_id}
              onChange={(e) => setBuildingID(e.target.value)}
              innerRef={register({
                register: true,
                validate: (value) => value !== "",
              })}
              className={classnames({
                "is-invalid": errors.building_id,
                // add extended bootstrap class for show invalid field value
              })}
            />
          </FormGroup>
          <FormGroup className="d-flex">
            <EventActions />
          </FormGroup>
        </Form>
      </ModalBody>
    </Modal>
  );
};

export default AddEventSidebar;
